import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import SEOEditorial from './components/SEOEditorial';
import TrustSection from './components/TrustSection';
import CTABanner from './components/CTABanner';
import Testimonial from './components/Testimonial';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL;

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <SEOEditorial />
        <TrustSection />
        <CTABanner />
        <Testimonial />
      </main>
      <Footer />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Kakobuy Finds",
          "url": siteUrl,
          "description": "Największa polska baza znalezisk zakupowych Kakobuy Spreadsheet – kategorie, porównania i poradniki.",
          "inLanguage": "pl-PL",
          "publisher": {
            "@type": "Organization",
            "name": "Kakobuy Finds",
            "url": siteUrl,
          },
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Kakobuy Finds",
          "url": siteUrl,
          "description": "Największa polska baza znalezisk zakupowych Kakobuy Spreadsheet – kategorie, porównania i poradniki.",
          "sameAs": [
            "https://kaspreadsheet.com",
          ],
        })}
      </script>
    </>
  );
}